import { ChangeDetectionStrategy, Component } from '@angular/core'
import { map } from 'rxjs'
import { SelectedItemFacade } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.facade'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'gb-item-terms-and-conditions-dialog',
  templateUrl: './gb-item-terms-and-conditions-dialog.component.html',
  styleUrls: ['./gb-item-terms-and-conditions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbItemTermsAndConditionsDialogComponent {
  termsAndConditionsHtml$ = this.selectedItemFacade.selectedItemTnC$.pipe(
    map((termsAndConditions) => this.domSanitizer.bypassSecurityTrustHtml(termsAndConditions)),
  )

  constructor(private selectedItemFacade: SelectedItemFacade, private domSanitizer: DomSanitizer) {}
}
